<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="客户：">
            <el-select size="medium" filterable v-model="searchForm.TC_ID" placeholder="请选择客户" clearable @change="isQueryProject">
              <el-option v-for="item in customer" :key="item.ID" :label="item.AB_NAME" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目点：">
            <el-select size="medium" filterable v-model="searchForm.PROJECT_ID" placeholder="请选择项目点" clearable
              @change="isQueryProjectId">
              <el-option v-for="item in project" :key="item.ID" :label="item.NAME" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分类：">
            <el-select size="medium" filterable v-model="searchForm.CAT_ID" placeholder="请选择分类" clearable @change="isQueryCatId">
              <el-option v-for="item in tableDataKinds" :key="item.ID" :label="item.CATALOG_NAME" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期范围：">
            <el-date-picker size="medium" v-model="searchForm.DATE" type="date" placeholder="请选择日期" style="width: 200px">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" class="btn" @click="query">筛选</el-button>
            <el-button size="medium" class="btn" @click="$_print">打印当前页标签</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" stripe border>
          <el-table-column label="序号" type="index" width="50px"></el-table-column>
          <el-table-column label="分类" prop="CATALOG_NAME" min-width="100px"></el-table-column>
          <el-table-column label="名称" prop="NAME" min-width="100px"></el-table-column>
          <el-table-column label="项目点" prop="PROJECT_NAME"></el-table-column>
          <el-table-column label="档口" prop="STALL_NAME"></el-table-column>
          <el-table-column label="送货数量" prop="NEED_COUNT" min-width="100px"></el-table-column>
          <!-- <el-table-column v-for="item in kinds" :key="item.TYPE_ID" :label="item.TYPE_NAME" :prop="String(item.TYPE_ID)"></el-table-column> -->
          <el-table-column label="产地" prop="PRODUCING_AREA"></el-table-column>
          <el-table-column label="上市日期" prop="SEND_DAY"></el-table-column>
          <el-table-column label="生产日期" prop="PRODUCTION_DATE"></el-table-column>
          <el-table-column label="保质期">
            <template slot-scope="scope">
              <span>{{ scope.row.QGP + QGP_TIME_TYPE[scope.row.QGP_TIME_TYPE] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="保质期至" prop="EXPIRY_DATE"></el-table-column>
          <el-table-column label="储存条件" prop="STORE_CONDITION"></el-table-column>
          <el-table-column label="操作" width="200px">
            <template slot-scope="scope">
              <el-button type="text" @click="$_printOne(scope.row)">打印</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { selectTCFun, selectProjectFun, queryPrint } from 'api/sellOrder';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      searchForm: {
        DATE: new Date().setDate(new Date().getDate() + 1),
      },
      tableData: [],
      kinds: [],
      customer: [],
      project: [],
      currentPage: 1,
      pageSize: 15,
      totalCount: 0,
      tableDataKinds: [],
      QGP_TIME_TYPE: ['', '年', '季', '个月', '天', '小时'],
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.$set(this.searchForm, 'PROJECT_ID', this.$store.state.S_PRINT_ALL.PROJECT_ID);
    this.$set(this.searchForm, 'TC_ID', this.$store.state.S_PRINT_ALL.TC_ID);
    this.$set(this.searchForm, 'CAT_ID', this.$store.state.S_PRINT_ALL.CAT_ID);
    if (this.$store.state.S_PRINT_ALL.PROJECT_ID) {
      this.queryProject();
    }
    this.queryCustomer();
    this.query();
    this.queryTable();
  },
  methods: {
    // 获取分类
    queryTable() {
      const params = {
        SERVICE_ID: '10049',
        OTYPE: 4,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
        PAGESIZE: 99999,
        PAGEINDEX: 0,
      };
      // this.loading = true
      http.post(params).then((result) => {
        this.tableDataKinds = result[0].OP_ROLE;
        // this.totalCount = result[0].TOTAL_COUNT
        // this.loading = false
      }).catch((error) => {
        // this.loading = false
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    // 改变项目点
    isQueryProjectId() {
      this.$store.dispatch(
        'S_PRINT_ALL',
        { TC_ID: this.searchForm.TC_ID, PROJECT_ID: this.searchForm.PROJECT_ID, CAT_ID: this.searchForm.CAT_ID },
      );
    },
    // 改变分类
    isQueryCatId() {
      this.$store.dispatch(
        'S_PRINT_ALL',
        { TC_ID: this.searchForm.TC_ID, PROJECT_ID: this.searchForm.PROJECT_ID, CAT_ID: this.searchForm.CAT_ID },
      );
    },
    // 获取客户
    queryCustomer() {
      selectTCFun()
        .then((result) => {
          this.customer = result[0].company;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    isQueryProject() {
      this.project = [];
      this.$set(this.searchForm, 'PROJECT_ID', '');
      if (this.searchForm.TC_ID) {
        this.queryProject();
      }
      this.$store.dispatch(
        'S_PRINT_ALL',
        { TC_ID: this.searchForm.TC_ID, PROJECT_ID: this.searchForm.PROJECT_ID, CAT_ID: this.searchForm.CAT_ID },
      );
    },
    // 项目点
    queryProject() {
      const params = {
        TC_ID: this.searchForm.TC_ID,
      };
      selectProjectFun(params)
        .then((result) => {
          // this.project = result
          this.project = result[0].list;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    checkDate(time) {
      return `${new Date(time).getFullYear()}-${(new Date(time).getMonth() + 1) < 10 ? (`0${new Date(time).getMonth() + 1}`) : (new Date(time).getMonth() + 1)}-${(new Date(time).getDate()) < 10 ? (`0${new Date(time).getDate()}`) : (new Date(time).getDate())}`;
    },
    // 筛选
    query() {
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.DATE != null) {
        params.REG_DATE = this.checkDate(this.searchForm.DATE);
      }
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      if (this.searchForm.PROJECT_ID) {
        params.PROJECT_ID = this.searchForm.PROJECT_ID;
      }
      if (this.searchForm.CAT_ID) {
        params.CAT_ID = this.searchForm.CAT_ID;
      }
      queryPrint(params)
        .then((result) => {
          if (result.length !== 0) {
            this.tableData = result[0].PRODUCT_INFO;
            this.totalCount = result[0].TOTAL_COUNT;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 分页
    handleCurrentChange() {
      this.query();
    },
    /**
       * 打印页面数据
       * @param {String} content html流
       * @param {*} w 长度
       * @param {*} h 高度
       */
    print(content, footer = '', isRow = true, w = null, h = null) {
      content += footer;
      const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
      const dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;
      const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
      const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
      w = +w === 0 ? width : w;
      h = +h === 0 ? height : h;
      const left = ((width / 2) - (w / 2)) + dualScreenLeft;
      const top = ((height / 2) - (h / 2)) + dualScreenTop;
      const myWindow = window.open('', '打印', `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=yes, copyhistory=no, width=${w}, height=${h}, top=${top}, left=${left}`);
      // 打印表格样式
      // let style = "<style type='text/css'>.main{height:43px;} .title {font-size: 30px;text-align: center; margin-bottom: 15px} .head{width: 100%; display: flex; justify-content: space-between;margin-bottom: 15px} .divFooter{position: fixed; display: flex; justify-content: space-between;bottom: 0;}.divFooter>div{margin-right: 100px} table{width: 100%} table.el-table__body {width: 600px;font-family: verdana,arial,sans-serif;font-size:11px;color:#333333;border-width: 1px;border-color: #666666;border-collapse: collapse}table.el-table__body, table.el-table__header th {border-width: 1px;padding: 5px;border-style: solid;border-color: #666666;background-color: #dedede}table.el-table__body td {border-width: 1px;padding: 5px;border-style: solid;border-color: #666666;background-color: #ffffff}}</style>"
      const style = "<style type='text/css'>*{margin: 0;padding: 0;} .name{font-size:12px;} @media print{.container {page-break-after: always;}} .container{font-size:12px;margin: 0 auto;width: 60mm;display: flex;flex-direction: column; align-items: center;} .center{} .two_line{display: flex;justify-content: space-between;} .shop_name{}</style>";
      myWindow.document.write(content + style);
      myWindow.focus();
      myWindow.document.close(); // 关闭document的输出流, 显示选定的数据
      myWindow.print.portrait = isRow;
      myWindow.print(); // 打印当前窗口
      return myWindow;
    },
    // 打印当前行
    $_printOne(row) {
      let html = '';
      html += '<div class="container">';
      html += '<div class="center">';
      html += '<div class="name">';
      html += `<span style="font-size:18px;">${row.PROJECT_NAME}-${row.STALL_NAME}</span>`;
      html += '</div>';
      html += '<div class="two_line">';
      html += `<span style="font-size:17px;">名称：${row.NAME}</span>`;
      html += '</div>';
      html += '<div class="">';
      html += `<span style="font-size:16px;">送货数量：${row.NEED_COUNT}${row.TYPE_UNIT}</span>`;
      html += '</div>';
      html += '<div class="">';
      html += `<span>原料产地：${row.PRODUCING_AREA}</span>`;
      html += '</div>';
      if (row.QGP_TIME_TYPE != 0 && row.QGP != 0) {
        html += '<div>';
        html += `<span style="font-size:16px;">上市日期：${row.SEND_DAY}</span>`;
        html += '</div>';
      } else {
        html += '<div>';
        html += `<span style="font-size:16px;">生产日期：${row.PRODUCTION_DATE}</span>`;
        html += '</div>';
        html += '<div>';
        html += `<span style="font-size:16px;">保质期至：${row.EXPIRY_DATE}</span>`;
        html += '</div>';
      }
      html += '<div>';
      html += `<span>存储条件：${row.STORE_CONDITION}</span>`;
      html += '</div>';
      html += '<div class="supllier">';
      html += `<span>供应商：${row.SUPPLIER_NAME}</span>`;
      html += '</div>';
      html += '<div class="supllier">';
      html += `<span>地址：${row.ADDRESS}</span>`;
      html += '</div>';
      html += '</div>';
      html += '</div>';
      const printFoot = '';
      const _windows = this.print(html, printFoot);
    },
    // 打印
    $_print() {
      let html = '';
      this.tableData.forEach((item, index) => {
        html += '<div class="container">';
        html += '<div class="center">';
        html += '<div class="name">';
        html += `<span style="font-size:18px;">${item.PROJECT_NAME}-${item.STALL_NAME}</span>`;
        html += '</div>';
        html += '<div class="two_line">';
        html += `<span style="font-size:17px;">名称：${item.NAME}</span>`;
        html += '</div>';
        html += '<div class="">';
        html += `<span style="font-size:16px;">送货数量：${item.NEED_COUNT}${item.TYPE_UNIT}</span>`;
        html += '</div>';
        html += '<div class="">';
        html += `<span>原料产地：${item.PRODUCING_AREA}</span>`;
        html += '</div>';
        if (item.EXPIRATION_DAY == 30) {
          html += '<div>';
          html += `<span style="font-size:16px;">上市日期：${item.SEND_DAY}</span>`;
          html += '</div>';
        } else {
          html += '<div>';
          html += `<span style="font-size:16px;">生产日期：${item.PRODUCTION_DATE}</span>`;
          html += '</div>';
          html += '<div>';
          html += `<span style="font-size:16px;">保质期至：${item.EXPIRY_DATE}</span>`;
          html += '</div>';
        }
        html += '<div>';
        html += `<span>存储条件：${item.STORE_CONDITION}</span>`;
        html += '</div>';
        html += '<div class="supllier">';
        html += `<span>供应商：${item.SUPPLIER_NAME}</span>`;
        html += '</div>';
        html += '<div class="supllier">';
        html += `<span>地址：${item.ADDRESS}</span>`;
        html += '</div>';
        html += '</div>';
        html += '</div>';
      });
      const printFoot = '';
      const _windows = this.print(html, printFoot);
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/sortingAndDistribution/s_print.vue